import { Dropdown, DropdownTrigger, DropdownMenu, DropdownItem, User } from "@heroui/react";
import { logout } from "../../redux/actions/authAction";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import profileLogo from "../../assets/OGOGLOGOG.svg";

export default function Profile({ user }) {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const Logo = user?.logo;

  const handleLogout = () => {
    dispatch(logout());
    navigate("/login", { replace: true });
  };

  return (
    <div className="flex items-center gap-4">
      <Dropdown placement="bottom-start">
        <DropdownTrigger>
          <User
            as="button"
            avatarProps={{
              isBordered: true,
              // src: "https://i.pravatar.cc/150?u=a042581f4e29026024d",
              src: Logo ? profileLogo : Logo,
            }}
            className="transition-transform font-bold"
            description={user?.type}
            name={user?.name}
          />
        </DropdownTrigger>
        <DropdownMenu aria-label="User Actions" variant="flat">
          <DropdownItem key={`${user?._id}-profile`} textValue={`${user?._id}-profile`} className="h-14 gap-2">
            <p className="font-bold">Signed in as</p>
            <p className="font-bold">{user?.email}</p>
          </DropdownItem>
          <DropdownItem key={`${user?._id}-settings`} textValue={`${user?._id}-settings`} asChild><Link to="/settings" className="w-full block">My Settings</Link></DropdownItem>
          <DropdownItem key={`${user?._id}-team_settings`} textValue={`${user?._id}-team_settings`} asChild><Link to="/settings?tab=ChangePassword" className="w-full block">Change password</Link></DropdownItem>
          <DropdownItem key={`${user?._id}-logout`} textValue={`${user?._id}-logout`} className="text-black hover:bg-primary transition-all duration-300" onPress={handleLogout} color="bg-primary">
            Log Out
          </DropdownItem>
        </DropdownMenu>
      </Dropdown>
    </div>
  );
}
